(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/router.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.bingo.Router = Backbone.Router.extend({
    routes: svs.core.data.routes,
    initialize() {
      svs.bingo.logger.debug('svs.router.bingo.initialize');
      let browserButtonNavigation = false;
      const originalLoadUrl = Backbone.history.loadUrl;

      Backbone.history.loadUrl = function () {
        if (browserButtonNavigation && Backbone.history.location.pathname === '/bingo') {
          window.location.href = Backbone.history.location.pathname;
          return false;
        }
        browserButtonNavigation = false;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return originalLoadUrl.apply(this, args);
      };
      window.onpopstate = function () {
        browserButtonNavigation = true;
      };
    },
    before() {
      $('.main-content').addClass('full-width');
      svs.bingo.nyxChannel.request('resetHeader', !Backbone.history.getFragment() || Boolean(~Backbone.history.fragment.indexOf('mina-spel/pagaende')));
      svs.bingo.mainRegion.currentView && !svs.bingo.mainRegion.currentView.isDestroyed && svs.bingo.mainRegion.currentView.destroy();
    },
    routeStart() {
      svs.bingo.nyxChannel.request('hideBackground');
      svs.bingo.logger.debug('svs.router.bingo.routeStart');
      svs.core.template.updateConfig({
        hideBalanceBarInXsSm: false
      });
      svs.bingo.nyxChannel.request('startpageOptions').then(startPageConfig => {
        svs.bingo.mainRegion.show(new svs.bingo.views.Start({
          startPageConfig
        }));
        $('.main-content').removeClass('full-width');
      });
    },
    spelguide(tab) {
      svs.bingo.logger.debug('svs.router.bingo.spelguide');
      svs.core.template.updateConfig({
        hideBalanceBarInXsSm: false
      });
      this.routeStart();
      svs.bingo.nyxChannel.request('showSpelguide', tab);
    },
    betDetailGame(wagerId) {
      svs.bingo.logger.debug('svs.router.bingo.betDetail');
      svs.core.template.updateConfig({
        hideBalanceBarInXsSm: false
      });
      if (wagerId) {
        svs.bingo.mainRegion.show(new svs.bingo.views.MyBets({
          wagerId
        }));
      } else {
        this.gameNotFound();
      }
    },
    betDetail(wagerId) {
      svs.accountservices.player_exclusions.canPlayOnVertical('bingo', canPlay => {
        if (canPlay) {
          this.betDetailGame(wagerId);
        } else {
          this.gameNotFound();
        }
      });
    },
    onGoingBets() {
      svs.bingo.logger.debug('svs.router.bingo.onGoingBets');
      svs.core.template.updateConfig({
        hideBalanceBarInXsSm: false
      });
      if (!svs.bingo.data.activeWagers.length) {
        svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.SPORT,
          title: 'Det finns inga pågående spel',
          icon: 'help-2',
          area: svs.ui.dialog.area.POPUP,
          type: svs.ui.dialog.type.CONFIRM,
          message: [{
            type: svs.ui.dialog.message.TEXT,
            text: 'Ditt pågående spel har avslutats. Du hittar dina tidigare spel under avgjorda spel på Mina spel-sidan'
          }],
          actions: [{
            title: 'Till Mina spel',
            callback() {
              location.href = '/mina-spel';
            }
          }]
        }));
        return;
      }
      const collection = new Backbone.Collection(svs.bingo.data.activeWagers, {
        model: svs.bingo.models.Wager
      });
      const accuiredWagerId = this.getWagerIdFromURI();
      let wagerId;
      if (this.isWagerIdActive(accuiredWagerId)) {
        wagerId = accuiredWagerId;
      } else {
        wagerId = collection.models[0].get('wagerId');
        this.navigate("mina-spel/pagaende/".concat(wagerId), {
          trigger: false
        });
      }
      if (svs.bingo.data.activeWagers.length >= 2) {
        svs.components.headerslidedownmenu.init({
          view: svs.bingo.views.OnGoingBetsList,
          viewOptions: {
            collection
          },
          customBtnClass: 'btn-transparent-default'
        });
        svs.components.headerslidedownmenu.show();
      }
      if (!svs.core.detect.formfactor.mobile()) {
        svs.bingo.mainRegion.show(new svs.bingo.views.MyBets({
          wagerId
        }));
      }
    },
    playGame(gameId) {
      if (gameId) {
        svs.bingo.nyxChannel.request('startpageOptions').then(startPageConfig => {
          const availableGames = startPageConfig.promoRegion.defaultPromo.items.models;
          let i = availableGames.length;
          gameId = +gameId;
          while (i--) {
            if (availableGames[i].get('id') === gameId) {
              svs.bingo.mainRegion.show(new svs.bingo.views.Play({
                model: new svs.bingo.models.Play({
                  activeGames: availableGames,
                  gameId,
                  gameName: availableGames[i].get('name')
                }, {
                  parse: true
                })
              }));
              return;
            }
          }
          this.gameNotFound();
        });
      } else {
        this.gameNotFound();
      }
    },
    play(gameId) {
      svs.core.template.updateConfig({
        hideBalanceBarInXsSm: true
      });
      svs.bingo.nyxChannel.request('hasAlias').then(hasAlias => {
        if (hasAlias) {
          svs.bingo.logger.debug('svs.router.bingo.play');
          svs.accountservices.player_exclusions.canPlayOnVertical('bingo', canPlay => {
            if (canPlay) {
              this.playGame(gameId);
            } else {
              this.gameNotFound();
            }
          });
        } else {
          const dialog = new svs.ui.dialog.Confirm({
            branding: svs.ui.dialog.branding.SPORT,
            title: 'Alias',
            icon: 'exclamation-sign',
            area: svs.ui.dialog.area.POPUP,
            type: svs.ui.dialog.type.CONFIRM,
            product: 'Bingo',
            message: [{
              type: svs.ui.dialog.message.TEXT,
              text: 'För att spela Bingo behöver du sätta ett alias.'
            }],
            actions: [{
              title: 'Avbryt',
              callback: () => {
                dialog.close();
              }
            }, {
              title: 'Sätt alias',
              callback: () => {
                svs.utils.url.navigate("".concat(svs.core.urlMapping.get('myProfileHome'), "/uppgifter/alias?returnUrl=").concat(svs.utils.url.currentPathEncodedParams()));
              }
            }]
          });
          svs.ui.dialog.api.add(dialog);
        }
      });
    },
    gameNotFound() {
      svs.bingo.router.navigate('/', {
        trigger: true
      });
    },
    getWagerIdFromURI() {
      const fragments = Backbone.history.fragment.split('/');
      return fragments[fragments.length - 1];
    },
    isWagerIdActive(wagerId) {
      for (let i = 0; i < svs.bingo.data.activeWagers.length; i++) {
        if (svs.bingo.data.activeWagers[i].wagerId === wagerId) {
          return true;
        }
      }
      return false;
    }
  });
})(Backbone, _, svs);

 })(window);